
import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { NotificationProductData } from "@/types/notifications";
import ProductItem from "./ProductItem";
import ProductSearchResults from "./ProductSearchResults";

interface ProductListProps {
  products: NotificationProductData[];
  activeField: { index: number, field: string } | null;
  showResults: boolean;
  isLoading: boolean;
  results: any[];
  updateProductField: (index: number, field: keyof NotificationProductData, value: string | number) => void;
  removeProduct: (index: number) => void;
  addNewProduct: () => void;
  handleInputFocus: (index: number, field: string) => void;
  handleInputBlur: () => void;
  selectProduct: (product: any, index: number) => void;
}

const ProductList = ({
  products,
  activeField,
  showResults,
  isLoading,
  results,
  updateProductField,
  removeProduct,
  addNewProduct,
  handleInputFocus,
  handleInputBlur,
  selectProduct
}: ProductListProps) => {
  return (
    <div className="space-y-4 mb-4">
      {products.map((product, index) => (
        <div key={index} className="relative">
          <ProductItem
            product={product}
            index={index}
            updateProductField={updateProductField}
            removeProduct={removeProduct}
            handleInputFocus={handleInputFocus}
            handleInputBlur={handleInputBlur}
          />
          
          {/* Search results for this product */}
          {activeField?.index === index && activeField?.field === 'product_sku' && (
            <ProductSearchResults
              isLoading={isLoading}
              results={results}
              selectProduct={(product) => selectProduct(product, index)}
              visible={showResults}
            />
          )}
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={addNewProduct}
        className="w-full"
      >
        <Plus className="h-4 w-4 mr-2" />
        Product toevoegen
      </Button>
    </div>
  );
};

export default ProductList;
